@if (isRestoring) {
  <div
    [ngStyle]="{
      'text-align': image.inlineStyle.textAlignment,
      'background-color': image.inlineStyle.backgroundColor,
      'padding-left': image.inlineStyle.paddingLeft,
      'padding-right': image.inlineStyle.paddingRight,
      'padding-top': image.inlineStyle.paddingTop,
      display: image.inlineStyle.ImageVerticalAlignment ? 'flex' : null,
      'flex-direction': image.inlineStyle.ImageVerticalAlignment ? 'column' : null,
      'justify-content': image.inlineStyle.ImageVerticalAlignment === 'Top' ? 'flex-start' : image.inlineStyle.ImageVerticalAlignment === 'Bottom' ? 'flex-end' : image.inlineStyle.ImageVerticalAlignment === 'Middle' ? 'center' : null,
      'align-items': image.inlineStyle.textAlignment === 'left' ? 'flex-start' : image.inlineStyle.textAlignment === 'right' ? 'flex-end' : image.inlineStyle.textAlignment === 'center' ? 'center' : null,
    }"
    class="bordered-image">
    <div
      class="image-wrapper"
      [ngStyle]="{
        'margin-top': image.inlineStyle.marginTop,
        'margin-bottom': image.inlineStyle.marginBottom,
        'margin-left': image.inlineStyle.marginLeft,
        'margin-right': image.inlineStyle.marginRight,
      }">
      <img
        #imageEl
        [src]="image.img"
        [ngStyle]="{
          width: image.inlineStyle.width,
          height: image.inlineStyle.height,
          'object-fit': 'cover',
          'border-top-left-radius': image.inlineStyle.ImageBorderRadiusTopLeft,
          'border-top-right-radius': image.inlineStyle.ImageBorderRadiusTopRight,
          'border-bottom-left-radius': image.inlineStyle.ImageBorderRadiusBottomLeft,
          'border-bottom-right-radius': image.inlineStyle.ImageBorderRadiusBottomRight,
        }" />
    </div>
  </div>
} @else {
  <div
    [ngStyle]="{
      'text-align': workingImage.inlineStyle.textAlignment,
      'background-color': workingImage.inlineStyle.backgroundColor,
      'padding-left': workingImage.inlineStyle.paddingLeft,
      'padding-right': workingImage.inlineStyle.paddingRight,
      'padding-top': workingImage.inlineStyle.paddingTop,
      display: workingImage.inlineStyle.ImageVerticalAlignment ? 'flex' : null,
      'flex-direction': workingImage.inlineStyle.ImageVerticalAlignment ? 'column' : null,
      'justify-content': workingImage.inlineStyle.ImageVerticalAlignment === 'Top' ? 'flex-start' : workingImage.inlineStyle.ImageVerticalAlignment === 'Bottom' ? 'flex-end' : workingImage.inlineStyle.ImageVerticalAlignment === 'Middle' ? 'center' : null,
      'align-items': workingImage.inlineStyle.textAlignment === 'left' ? 'flex-start' : workingImage.inlineStyle.textAlignment === 'right' ? 'flex-end' : workingImage.inlineStyle.textAlignment === 'center' ? 'center' : null,
      width: isCropPreviewWidened ? cropPreviewWidenedWidth + 'px' : null,
      transform: isCropPreviewWidened ? 'translateX(' + cropPreviewCenterShiftPx + 'px)' : null,
    }"
    class="bordered-image"
    [class.crop-preview-widened]="isCropPreviewWidened">
    @if (imageFit === "Fill") {
      <div class="fill-scroll-info" [matTooltip]="fillDragAxis === 'horizontal' ? 'Drag or scroll the image left or right to reposition.' : 'Drag or scroll the image up or down to reposition.'">
        <img [src]="iconService.Icon.drag_updown" />
      </div>
    }

    @if (imageFit === "Crop") {
      <div class="fill-scroll-info" matTooltip="Drag the box to reposition it. Use handles or mousewheel to resize it.">
        <img [src]="iconService.Icon.drag_updown" />
      </div>
    }
    <div
      class="image-wrapper"
      [class.crop-preview-widened]="isCropPreviewWidened"
      [ngStyle]="{
        'margin-top': workingImage.inlineStyle.marginTop,
        'margin-bottom': workingImage.inlineStyle.marginBottom,
        'margin-left': imageFit === 'Crop' ? '0' : workingImage.inlineStyle.marginLeft,
        'margin-right': imageFit === 'Crop' ? '0' : workingImage.inlineStyle.marginRight,
      }"
      (mouseenter)="isHoveringImage = true"
      (mouseleave)="isHoveringImage = false">
      @if (rotationClip) {
        <!-- Original / Crop 90°/270°: clip wrapper, image rotated inside via CSS -->
        <div [ngStyle]="{ width: rotationClip.w + 'px', height: rotationClip.h + 'px', overflow: 'hidden', display: 'flex', 'align-items': 'center', 'justify-content': 'center' }">
          <img
            [ngStyle]="{
              width: workingImage.inlineStyle.width,
              height: workingImage.inlineStyle.height,
              'max-width': 'none',
              'max-height': 'none',
              transform: 'rotate(' + imageRotation + 'deg)',
              'flex-shrink': '0',
              'border-top-left-radius': imageFit !== 'Crop' ? rotatedBorderRadius.tl : '0px',
              'border-top-right-radius': imageFit !== 'Crop' ? rotatedBorderRadius.tr : '0px',
              'border-bottom-left-radius': imageFit !== 'Crop' ? rotatedBorderRadius.bl : '0px',
              'border-bottom-right-radius': imageFit !== 'Crop' ? rotatedBorderRadius.br : '0px',
            }"
            [class.transitioning-fit]="isFitTransitioning"
            [src]="workingImage.img"
            #imageEl />
        </div>
      } @else if (fillImgSize) {
        <!-- Fill 90°/270°: clip div at display size, img absolutely centered then rotated.
             object-fit:none overrides the global .image-wrapper img { object-fit:cover } rule
             so the browser honours our explicit DOM width/height before rotating. -->
        <div
          [ngStyle]="{
            width: workingImage.inlineStyle.width,
            height: workingImage.inlineStyle.height,
            position: 'relative',
            overflow: 'hidden',
            cursor: isFillDragging ? 'grabbing' : 'grab',
            'border-top-left-radius': rotatedBorderRadius.tl,
            'border-top-right-radius': rotatedBorderRadius.tr,
            'border-bottom-left-radius': rotatedBorderRadius.bl,
            'border-bottom-right-radius': rotatedBorderRadius.br,
          }"
          (mousedown)="onFillImageMouseDown($event)">
          <img
            class="fill-rotated-img"
            [ngStyle]="{
              width: fillImgSize.w + 'px',
              height: fillImgSize.h + 'px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: `translate(-50%, -50%) translate(${fillDragX}px, ${fillDragY}px) rotate(${imageRotation}deg)`,
              'object-fit': 'cover',
              'pointer-events': 'none',
            }"
            [class.transitioning-fit]="isFitTransitioning"
            [src]="workingImage.img"
            #imageEl />
        </div>
      } @else {
        <img
          [ngStyle]="{
            width: workingImage.inlineStyle.width,
            height: workingImage.inlineStyle.height,
            'object-position': imageFit === 'Fill' ? 'calc(50% + ' + fillDragX + 'px) calc(50% + ' + fillDragY + 'px)' : null,
            cursor: imageFit === 'Fill' ? (isFillDragging ? 'grabbing' : 'grab') : null,
            'border-top-left-radius': imageFit !== 'Crop' ? rotatedBorderRadius.tl : '0px',
            'border-top-right-radius': imageFit !== 'Crop' ? rotatedBorderRadius.tr : '0px',
            'border-bottom-left-radius': imageFit !== 'Crop' ? rotatedBorderRadius.bl : '0px',
            'border-bottom-right-radius': imageFit !== 'Crop' ? rotatedBorderRadius.br : '0px',
            transform: imageRotation !== 0 ? 'rotate(' + imageRotation + 'deg)' : null,
          }"
          [class.transitioning-fit]="isFitTransitioning"
          [src]="workingImage.img"
          (mousedown)="imageFit === 'Fill' ? onFillImageMouseDown($event) : null"
          #imageEl />
      }

      @if (imageFit === "Crop") {
        <div class="crop-box" #cropBoxEl [style.left.px]="cropBox.x" [style.top.px]="cropBox.y" [style.width.px]="cropBox.w" [style.height.px]="cropBox.h" (mousedown)="onCropBoxDown($event)" (mouseenter)="isHoveringCropBox = true" (mouseout)="onCropBoxMouseOut($event, cropBoxEl)">
          <div *ngIf="cropShape === 'Freeform'" class="crop-handle crop-handle--top" (mousedown)="onCropHandleDown($event, 'top')"></div>
          <div *ngIf="cropShape === 'Freeform'" class="crop-handle crop-handle--bottom" (mousedown)="onCropHandleDown($event, 'bottom')"></div>
          <div *ngIf="cropShape === 'Freeform'" class="crop-handle crop-handle--left" (mousedown)="onCropHandleDown($event, 'left')"></div>
          <div *ngIf="cropShape === 'Freeform'" class="crop-handle crop-handle--right" (mousedown)="onCropHandleDown($event, 'right')"></div>
          <div class="crop-handle crop-handle--topleft" (mousedown)="onCropHandleDown($event, 'topleft')"></div>
          <div class="crop-handle crop-handle--topright" (mousedown)="onCropHandleDown($event, 'topright')"></div>
          <div class="crop-handle crop-handle--bottomleft" (mousedown)="onCropHandleDown($event, 'bottomleft')"></div>
          <div class="crop-handle crop-handle--bottomright" (mousedown)="onCropHandleDown($event, 'bottomright')"></div>
        </div>
      }
    </div>
  </div>
}

<div class="adjust-sidebar" [class.sidebar-hd]="fromHD">
  <div class="sidebar-header" style="border-top: none">
    <p class="p-medium">Adjust Image</p>
  </div>
  <div class="sidebar-content">
    <p class="p-medium">Transform</p>

    @if (allowFillOption && !fromHD) {
      <ag-toggle-button option1="Original" option2="Fill" option3="Crop" [numberOfOptions]="3" [initValue]="imageFit" [widthPerOption]="84" [initEmit]="false" (chosenOption)="onImageFitChange($event)"></ag-toggle-button>
    } @else if (!fromHD) {
      <ag-toggle-button option1="Original" option2="Crop" [numberOfOptions]="2" [initValue]="imageFit === 'Fill' ? 'Original' : imageFit" [widthPerOption]="128" [initEmit]="false" (chosenOption)="onImageFitChange($event)"></ag-toggle-button>
    } @else {
      <ag-toggle-button option1="Fill" option2="Crop" [numberOfOptions]="2" [initValue]="imageFit" [widthPerOption]="128" [initEmit]="false" (chosenOption)="onImageFitChange($event)"></ag-toggle-button>
    }

    @if (imageFit === "Crop") {
      @if (!lockedAspectRatio) {
        <div class="flex-row" style="gap: 8px; flex-wrap: wrap">
          <div class="crop-button" [class.crop-button-active]="cropShape === 'Freeform'" (click)="onCropShapeChange('Freeform')">
            <img [src]="iconService.Icon.crop_freeform" />
            <p>Free</p>
          </div>
          <div class="crop-button" [class.crop-button-active]="cropShape === 'Original'" (click)="onCropShapeChange('Original')">
            <img [src]="iconService.Icon.crop_original" />
            <p>Original</p>
          </div>
          <div class="crop-button" [class.crop-button-active]="cropShape === 'Square'" (click)="onCropShapeChange('Square')">
            <img [src]="iconService.Icon.crop_square" />
            <p>1:1</p>
          </div>
          <div class="crop-button" [class.crop-button-active]="cropShape === '4:3'" [ngClass]="cropAligment === 'Horizontal' ? 'crop-flipped' : ''" (click)="onCropShapeChange('4:3')">
            <img [src]="iconService.Icon.crop_4_3" />
            <p>{{ cropAligment === "Horizontal" ? "3:4" : "4:3" }}</p>
          </div>
          <div class="crop-button" [class.crop-button-active]="cropShape === '16:9'" [ngClass]="cropAligment === 'Horizontal' ? 'crop-flipped' : ''" (click)="onCropShapeChange('16:9')">
            <img [src]="iconService.Icon.crop_16_9" />
            <p>{{ cropAligment === "Horizontal" ? "9:16" : "16:9" }}</p>
          </div>
          <div class="crop-button" [class.crop-button-active]="cropShape === '2:1'" [ngClass]="cropAligment === 'Horizontal' ? 'crop-flipped' : ''" (click)="onCropShapeChange('2:1')">
            <img [src]="iconService.Icon.crop_2_1" />
            <p>{{ cropAligment === "Horizontal" ? "1:2" : "2:1" }}</p>
          </div>
        </div>
        <ag-toggle-button [option1WithImage]="['Vertical', iconService.Icon.crop_16_9]" [option2WithImage]="['Horizontal', iconService.Icon.crop_16_9_horizontal]" [widthPerOption]="128" [imageAndText]="true" (chosenOption)="onAlignmentChange($event)"></ag-toggle-button>
      }
    }

    @if (imageFit === "Fill") {
      <p class="fill-drag-tip">
        <img [src]="iconService.Icon.i_letter_1_5" />
        {{ fillDragAxis === "horizontal" ? "Drag or scroll the image left or right to reposition." : "Drag or scroll the image up or down to reposition." }}
      </p>
    }
  </div>

  <div class="sidebar-content">
    <p class="p-medium">Rotation</p>
    <div class="rotation-buttons">
      <flow-button type="secondary" matTooltip="Rotate counterclockwise" width="128px" label="Left" size="small" [icon]="iconService.Icon.rotate_ccw" (click)="rotateBy(-90)"></flow-button>
      <flow-button type="secondary" matTooltip="Rotate clockwise" width="128px" label="Right" size="small" [icon]="iconService.Icon.rotate_cw" (click)="rotateBy(90)"></flow-button>
    </div>
  </div>

</div>
<div #infoToasterEl class="info-toaster" [hidden]="!(imageFit === 'Crop' && isCropPreviewWidened)" (click)="$event.stopPropagation()">
  <p class="p-medium">Image resized for better cropping view - actual output size is unaffected.</p>
</div>
<div #toasterEl class="action-toaster" [class.action-toaster--above-info]="imageFit === 'Crop' && isCropPreviewWidened" [hidden]="!clickedOutside() && !saveError()" (click)="$event.stopPropagation()">
  <p class="p-medium">{{ saveError() ?? "Save your image adjustments first - other elements are locked." }}</p>
  <img height="16" width="16" [src]="iconService.Icon.cross" (click)="saveError() ? dismissSaveError() : dismissClickedOutside.emit()" />
</div>
<div #taskbarEl class="action-taskbar" [class.action-taskbar-alert]="clickedOutside() || !!saveError()" (click)="$event.stopPropagation()">
  <flow-button type="secondary" width="114px" label="Discard" [disabled]="uploading" (click)="uploading ? null : cancel()"></flow-button>
  <flow-button width="114px" label="Save" [loading]="uploading || isRestoring" [disabled]="isRestoring" (click)="save()"></flow-button>
</div>
